import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { PersonalOfficeService } from '../services/personal-office.service';
import { TimemodelEntity } from '../../store/entities/TimemodelEntity';

@Injectable({
	providedIn: 'root',
})
export class PoTimemodelsResolver implements Resolve<TimemodelEntity[]> {
	constructor(private po: PersonalOfficeService) {}
	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<TimemodelEntity[]> | Promise<TimemodelEntity[]> | TimemodelEntity[] {
		return this.po.getTimemodelList().pipe(take(1));
	}
}
